import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  model,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IconComponent } from '@components';
import { BaseFormControlComponent } from '../../../shared/components/base-form-control/base-form-control.component';
import { FormLoadingSpinnerComponent } from '../../../shared/components/form-loading-spinner/form-loading-spinner.component';
import { FormControlDirective } from '../../../shared/directives/form-control/form-control.directive';
import { FormOption } from '../../../shared/models/form-option.interface';
import { ValidityIconComponent } from '../../../shared/components/validity-icon/validity-icon.component';

@Component({
  selector: 'app-form-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: BaseFormControlComponent,
      useExisting: forwardRef(() => SelectComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormControlDirective,
    FormLoadingSpinnerComponent,
    IconComponent,
    NgClass,
    ReactiveFormsModule,
    ValidityIconComponent,
  ],
  standalone: true,
})
export class SelectComponent extends BaseFormControlComponent<string> {
  fill = input<boolean>(false);
  options = input<FormOption[] | undefined>([]);
  placeholder = model<string>('Select an option');

  get loading(): boolean {
    return this.enabled && !this.options()?.length;
  }
}
